<template>
    <div class="group-inputs">

        <!-- <div class="f-90 gray-600 mb-1"> *NICE평가정보에서 ESG 평가 신청 후 계정 안내를 못 받으신 경우, <b>info@qesg.co.kr</b>로 문의 바랍니다.</div> -->

        <div class="gray-600 mb-1"> {{ $t(`성함`) }} *</div>
        <b-form-input v-model="name" class="mb-2" type='text'></b-form-input>

        <div class="gray-600 mb-1">{{ $t(`이메일`) }} *</div>
        <b-form-input v-model="e_mail" class="mb-2" type='text' placeholder="name@example.com"></b-form-input>

        <div class="gray-600 mb-1">{{ $t(`소속`) }}</div>
        <b-form-input v-model="company" class="mb-3" type='text' :placeholder="modal_company"></b-form-input>

        <div class="gray-600 mb-1">{{ $t(`문의사항`) }} *</div>
        <b-textarea v-model="requirements" rows="6" :placeholder="$t(`문의사항을 작성해 주세요.`)"></b-textarea>

        <div class="f-90 text-right mb-4">
            {{ $t(`평균 1시간 이내에 답변 드립니다. *은 필수입력 항목입니다.`) }}
        </div>

        <div v-if="mail_sending==false" class="d-flex justify-content-end mb-2">
            <b-button variant="dark" @click="hideModal">{{ $t(`취소`) }}</b-button>
            <b-button class="ml-2" variant="blue" @click="saveCustomerService">{{ $t(`문의하기`) }}
                <fa icon="paper-plane" class="ml-1"></fa>
            </b-button>
        </div>
        <div v-if="mail_sending==true" class="d-flex justify-content-end mb-2">
            <b-spinner size="small"></b-spinner>
            {{ $t(`문의사항을 전송하는 중입니다. 잠시 기다려 주세요.`) }}
        </div>

    </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
    name: 'customer-service',
    data() {
        return {
            selected: [],
            options: [
                {text: 'ESG 평가', value: 'ESG 평가'},
                {text: '지속가능경영 정보 공개', value: '웹 리포팅'},
                {text: '기타', value: '기타'}
            ],

            name: '',
            company: '',
            e_mail: '',
            requirements: '',
            is_form_filled: false,

            modal_company: this.$t('회사'),

            mail_sending: false,
        };
    },
    computed: {
        ...mapState({
            user_id: state => state.user_id,
            store_e_mail: state => state.e_mail,
            user_name: state => state.user_name,
            company_name: state => state.company_name,
            campaign_in_progress: state => state.campaign_in_progress,
            template_in_progress: state => state.template_in_progress,
            question_in_progress: state => state.question_in_progress
        })
    },
    created() {
        this.name = this.user_name;
        this.company = this.company_name;
        this.e_mail = this.store_e_mail;
        // console.log(this.campaign_in_progress.campaign_name);
        if (this.campaign_in_progress.campaign_name !== undefined || this.campaign_in_progress.campaign_name !== '') {
            this.requirements = this.$t(`${this.campaign_in_progress.campaign_name}`) + this.$t('관련 문의');
        } else {
            this.requirements = '';
        }
    },
    mounted() {
    },
    methods: {
        async saveCustomerService() {
            try {
                this.checkForm();
                if (this.is_form_filled != false) {
                    this.mail_sending = true;

                    let formData = new FormData;
                    formData.append('name', this.name);
                    formData.append('company', this.company);
                    formData.append('e_mail', this.e_mail);
                    formData.append('requirements', this.requirements);
                    formData.append('source', 'qesg_assessment');

                    await this.$axios.post('/save_customer_service', formData);
                    this.$emit('toast-success', this.$t('알림'), this.$t('문의사항을 접수하였습니다. 최대한 빠르게 답변드리도록 하겠습니다.'));
                    this.hideModal();

                    await this.$axios.post('/send_customer_service_mail', formData);
                } else {
                    alert(this.$t('필수 항목을 모두 입력하여 주십시오'));
                }
            } catch (error) {
                console.log(error);
            }
        },
        checkForm() {
            if (this.name !== '' && this.e_mail !== '' && this.requirements !== '') {
                this.is_form_filled = true;
            } else {
                this.is_form_filled = false;
            }
        },
        hideModal() {
            // this.$emit('close-need-help')
            this.$bvModal.hide('close-need-help');
        }

    }
};
</script>

<style scoped>

</style>
